<div class="charity-form">
   <!-- <nz-alert nzShowIcon *ngIf="stripeStatusInactive" nzType="error" nzMessage="Account is not registered yet to receive donation"></nz-alert> -->
   <h2>{{ 'donateFundraiserTitle' | translate }}</h2>
    <!-- <form nz-form [formGroup]="donateForm" (ngSubmit)="submitForm()" ngxStripeCardGroup [elementsOptions]="elementsOptions"> -->
   <form nz-form [formGroup]="donateForm" (ngSubmit)="submitForm()">
       <nz-alert class="m-b-10" nzType="success" nzMessage="{{'donatedSuccessfully' | translate}}" nzShowIcon *ngIf="donateSuccess"></nz-alert>
       <div class="row">
       <nz-form-item  class="col-lg-6">
          <nz-form-control nzErrorTip="{{'donateFirstNameError' | translate}}">
                <input type="text" nz-input formControlName="first_name" placeholder="{{'donateInputFirstName' | translate}}" id="firstName">
          </nz-form-control>
       </nz-form-item>

       <nz-form-item  class="col-lg-6">
          <nz-form-control nzErrorTip="{{'donateLastNameError' | translate}}">
                <input type="text" nz-input formControlName="last_name" placeholder="{{'donateInputLastName' | translate}}" id="lastName">
          </nz-form-control>
       </nz-form-item>

       <nz-form-item  class="col-lg-6">
          <nz-form-control nzErrorTip="{{'donateEmailError' | translate}}">
                <input type="email" nz-input formControlName="email" placeholder="{{'donateInputEmail' | translate}}" id="email">
          </nz-form-control>
       </nz-form-item>

       <nz-form-item  class="col-lg-6">
          <nz-form-control nzErrorTip="{{'donateMobileError' | translate}}">
                <input type="number" nz-input formControlName="mobile_number" placeholder="{{'donateInputPhoneNumber' | translate}}" id="phoneNumber">
          </nz-form-control>
       </nz-form-item>
    
       <nz-form-item  class="col-lg-12">
          <nz-form-control nzErrorTip="{{'donateAmountError' | translate}}">
                <nz-input-group nzAddOnBefore="$">
                   <input type="number" nz-input formControlName="amount" placeholder="{{'donateInputAmount' | translate}}" id="amount">
                </nz-input-group>
          </nz-form-control>
       </nz-form-item>

       <nz-form-item   class="col-lg-12">
          <nz-form-control nzErrorTip="{{'donateMessageError' | translate}}">
                <textarea rows="3" nz-input formControlName="message" placeholder="{{'donateInputMessage' | translate}}" id="message"></textarea>
          </nz-form-control>
       </nz-form-item>
       <div class="col-lg-12">
       <!-- <div nz-row class="card-info" [ngClass]="{'errorBorder' : showInvalidCardError}">
          <p class="card-header">{{ "paymentDetails" | translate }}</p>
          <div nz-col nzSpan="24" class="card-number-col">
                <ngx-stripe-card-number [options]="cardOptions"></ngx-stripe-card-number>
          </div>
          <div nz-col nzSpan="11" class="card-expiry-col">
                <ngx-stripe-card-expiry [options]="cardOptions"></ngx-stripe-card-expiry>
          </div>
          <div nz-col nzSpan="12" class="card-cvc-col" nzOffset="1">
                <ngx-stripe-card-cvc [options]="cardOptions"></ngx-stripe-card-cvc>
          </div>
       </div> -->
    </div>
       <p *ngIf="showInvalidCardError" class="err-msg">{{ "invalidCardErrorMessage" | translate }}</p>

       <div class="w-100">
          <nz-form-item>
                <nz-form-control>
                   <div class="text-center">
                      <button nz-button class="is-login-btn mt-20" [nzLoading]="isFormSaving" [nzType]="'primary'" >{{"leadSubmit" | translate}}</button>
                   </div>
                </nz-form-control>
          </nz-form-item>
       </div>
    </div>
    </form>
 </div>